import { useEffect } from "react";

export const useClickOutside = (ref: React.RefObject<HTMLElement>, handler: (event: Event) => void) => {
  const documentElement = () => {
    if (ref.current && ref.current.getRootNode() instanceof ShadowRoot) {
      return ref.current.getRootNode() as Document;
    }

    return document;
  };

  useEffect(() => {
    const listener = (event: Event) => {
      if (ref.current) {
        if (ref.current.contains(event.target as HTMLElement)) return;
        handler(event);
      }
    };

    documentElement().addEventListener("mousedown", listener);
    documentElement().addEventListener("touchstart", listener);

    return () => {
      documentElement().removeEventListener("mousedown", listener);
      documentElement().removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
